import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Dependant } from '../../models/dependant';

@Component({ standalone:false,
  selector: 'app-transformation-definition-confirmation-dialog',
  templateUrl: './transformation-definition-confirmation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './transformation-definition-confirmation-dialog.component.scss'
})
export class TransformationDefinitionConfirmationDialogComponent {
  title: string="Title";
  confirmButtonText="Save";
  cancelButtonText="Cancel";

  public dependants?:Dependant[];
  public dependantGroups:{type:string, label:string, dependants:Dependant[]}[]=[];
  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<TransformationDefinitionConfirmationDialogComponent>) {
    if(data){
      this.title=data.title;
      this.dependants=data.dependants;
      this.dependantGroups=Dependant.groupByType(data.dependants ?? []);
      if(data.buttonText){
        this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
        this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
      }
    }
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }
  onCancelClick(): void {
    this.dialogRef.close(false);
  }
}